import { useQuery } from '@tanstack/react-query';

const useGetData = (key: string, callApiFunction: () => void) => {
    const query = `get-data-${key}`
    const getDataQuery = useQuery({
        queryKey: [query],
        queryFn: callApiFunction,
        cacheTime: Infinity,
        staleTime: 1000 * 60 * 10,
        refetchOnWindowFocus: false,
    });

    let axiosResponse = getDataQuery.data as any;
    return {
        ...getDataQuery,
        data: axiosResponse
    };
}

export default useGetData;